import type { Product } from './schema';

/** Amazon Associates tag. Same tag the treatment catalogue uses (backend AMAZON_ASSOCIATE_TAG). */
export const AMAZON_TAG = 'roomtreatment-20';

/** Tagged Amazon product link, or null when the product has no verified ASIN. */
export function amazonUrl(p: Pick<Product, 'asin'>): string | null {
  return p.asin ? `https://www.amazon.com/dp/${p.asin}?tag=${AMAZON_TAG}` : null;
}

/** eBay US search for used and refurbished listings of this model. */
export function ebayUsedUrl(p: Pick<Product, 'brand' | 'model'>): string {
  const q = encodeURIComponent(`${p.brand} ${p.model}`);
  // LH_ItemCondition: 3000 used, 2000/2010/2020/2030 refurbished grades.
  return `https://www.ebay.com/sch/i.html?_nkw=${q}&LH_ItemCondition=3000%7C2000%7C2010%7C2020%7C2030`;
}
